import { DictItem } from "@/types/dict";
import dictApi, { dictListIgnoreEnum } from "@/apis/dict";
import { App, Button, Divider, Input, notification, Select, SelectProps } from "antd";
import { CheckOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

type SelectBrandNameProps<T> = Omit<SelectProps<T>, "options"> & { productType: string };

function SelectBrandName<T>(props: SelectBrandNameProps<T>) {
  const { productType, ...selctProps } = props;
  const { t } = useTranslation();
  const [brandName, setBrandName] = useState<DictItem[]>([]);

  const [isShowAdd, setIsShowAdd] = useState<boolean>(false);
  const [addVal, setAddVal] = useState<string>("");
  const [adding, setAdding] = useState<boolean>(false);
  const [openDrop, setOpenDrop] = useState<boolean>(false);

  // 按产品类型拉取品牌名称字典
  const fetchList = async () => {
    if (!productType) return;
    try {
      const list = await dictListIgnoreEnum(productType);
      setBrandName(list);
    } catch { }
  };

  useEffect(() => {
    if (openDrop) fetchList();
  }, [openDrop, productType]);

  const closeAdd = () => {
    setIsShowAdd(false);
    setAddVal("");
  };

  const handleAdd = () => {
    const desc = addVal.trim();
    if (!desc || brandName.some(item => item.desc === desc)) {
      closeAdd();
      return;
    }
    setAdding(true);
    dictApi.addIgnoreEnum(productType, { key: desc, desc })
      .then((res: DictItem) => {
        setBrandName([...brandName, res]);
        closeAdd();
      })
      .catch((err) => {
        notification.error({
          placement: 'top',
          message: t("common.addError"),
          description: err === 10010 ? t("common.networkError") : t("common.serverError"),
        });
      })
      .finally(() => setAdding(false));
  };

  return (
    <Select
      {...selctProps}
      showSearch
      open={openDrop}
      onDropdownVisibleChange={(open) => {
        setOpenDrop(open);
        if (!open) closeAdd();
        props.onDropdownVisibleChange?.(open);
      }}
      options={
        brandName.map(item => ({ key: item.id, label: item.desc, value: item.desc }))
      }
      filterOption={(input, option) =>
        String(option?.label ?? "").toLowerCase().includes(String(input).toLowerCase())
      }
      placeholder={t('purchase.brandName')}
      dropdownRender={(menu) => (
        <>
          {menu}
          <Divider style={{ margin: "8px 0" }} />
          {isShowAdd ? (
            <div style={{ display: "flex", gap: 4, padding: "0 4px" }}>
              <Input
                autoFocus
                size="small"
                value={addVal}
                onChange={(e) => setAddVal(e.target.value)}
                onPressEnter={handleAdd}
                placeholder={t('purchase.brandName')}
                maxLength={100}
              />
              <Button type="link" size="small" icon={<CheckOutlined />} loading={adding} onClick={handleAdd} />
              <Button type="link" size="small" danger icon={<CloseOutlined />} onClick={closeAdd} />
            </div>
          ) : (
            <Button
              type="text"
              size="small"
              style={{ width: "100%", color: "#1677ff" }}
              icon={<PlusOutlined />}
              onClick={() => setIsShowAdd(true)}
            >
              {t("common.add")}
            </Button>
          )}
        </>
      )}
    />
  )
};

export default SelectBrandName;
